import { render, staticRenderFns } from "./HeadingProductListItem.vue?vue&type=template&id=1ef1fcd1&"
import script from "./HeadingProductListItem.vue?vue&type=script&lang=ts&"
export * from "./HeadingProductListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports